var TECL_Master = {

    // Display error dialog
    ShowErrorDialog: function(errorMessage) {
        if (!errorMessage) {
            errorMessage = "Unknown error";
        }

        $("#errorText").html(errorMessage);
        $("#errorDialog").modal("show");
    },

    // Display save question dlg for a set amount of time
    DisplayNoticeDlg: function(displayText, callBackFnName) {
        $("#displayNoticeDlgText").html(displayText);
        $("#displayNoticeDialog").modal("show");

        function HideSupplierQuestionSavedDlg() {
            $("#displayNoticeDialog").modal("hide");

            if (callBackFnName) {
                // Get a reference to the actual function using the name
                var callBackFn = TECL_Master.GetFunctionByName(callBackFnName);

                if (callBackFn) {
                    callBackFn();
                }
            }
        }

        // Wait a set amount of time till the dialog is closed
        setTimeout(HideSupplierQuestionSavedDlg, 2000);
    },

    // Clear all the error text lines
    ClearErrorTextLines: function() {
        // Reset all error fields
        $(".field-validation-error").each(function() {
            $(this).addClass("hidden");
        });
    },

    // Reload the current page
    ReloadPage: function() {
        location.reload();
    },

    // Resize a text area while typing
    TextAreaAutoResize: function(txtArea, minHeight) {
        txtArea.style.height = "1px";

        var newHeight = (10 + txtArea.scrollHeight);
        if (minHeight > newHeight) {
            newHeight = minHeight;
        }

        txtArea.style.height = newHeight + "px";
    },

    // Do free text search
    RunFreeTextSearch: function(element, searchUrl, searchDescendantsOfNode, additionalSearchItemsKey, resultItemsPartialViewName) {
        var searchText;
        if (typeof element === 'undefined') {
            searchText = $("#freeTextSearch").val();
        } else {
            searchText = $(element).val();
        }

        searchDescendantsOfNode = searchDescendantsOfNode || 0;
        additionalSearchItemsKey = additionalSearchItemsKey || "";
        resultItemsPartialViewName = resultItemsPartialViewName || "";

        var nodeSearchParam = "";
        if (parseInt(searchDescendantsOfNode) > 0) {
            nodeSearchParam = "&searchDescendantsOfNode=" + searchDescendantsOfNode;
        }

        var searchKeyParam = "";
        if (additionalSearchItemsKey.length > 0) {
            searchKeyParam = "&additionalSearchItemsKey=" + additionalSearchItemsKey;
        }

        var viewParam = "";
        if (resultItemsPartialViewName.length > 0) {
            viewParam = "&resultItemsPartialViewName=" + resultItemsPartialViewName;
        }

        var url = "/umbraco/Surface/SearchResultsSurface/RunFreeTextSearch";
        if (searchText !== "") {
            searchUrl = searchUrl || "/searchresults";
            window.location.href = "/umbraco/Surface/SearchResultsSurface/RunFreeTextSearch?searchText=" +
                searchText +
                "&searchUrl=" +
                searchUrl +
                nodeSearchParam +
                searchKeyParam +
                viewParam;
        }
    },

    CheckFreeTextKeyDown: function(e) {
        if (e.keyCode === 13) {
            e.preventDefault();
            //Enter Key has been pressed
            TECL_Master.RunFreeTextSearch();
        }
    },

    // Check if the text is an email address
    IsEmailAddress: function(emailAddressText) {
        var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,10})?$/;
        var isEmailAddress = emailReg.test(emailAddressText);
        return isEmailAddress;
    },

    /*-------------------------------------------------------------------------------------
    The following JavaScript functions are for locking operations to prevent double clicking
    --------------------------------------------------------------------------------------*/
    LOCKVAR: null,

    // Attempt to add a lock to a key, if the key is already locked then return False, otherwise, add the lock and return True
    AddLock: function(key) {

        var lockCreated = false;

        if (key) {

            // Get the existing list of locks
            var locks = TECL_Master.LOCKVAR || [];

            if (!locks[key]) {
                // This key has not been locked so add it to the list of locks and return true
                locks[key] = true;
                TECL_Master.LOCKVAR = locks;
                lockCreated = true;
            }
        }

        return lockCreated;
    },

    // Remove the lock for key
    ClearLock: function(key) {

        if (key) {
            // Get the existing list of locks
            var locks = TECL_Master.LOCKVAR || [];

            // Delete the lock if required
            if (locks[key]) {
                delete locks[key];
                TECL_Master.LOCKVAR = locks;
            }
        }
    },

    GetParameterByName: function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    },

    // Stops a scrolling bug with the kendo dropdown control
    StopKendoDropDownScrollBug: function() {
        $("[data-role='dropdownlist']").each(function() {
            var widget = $(this).data("kendoDropDownList");
            if (widget) {
                TECL_Master.StopKendoScroll(widget.ul.parent());
            }
        });
    },

    // Stop scrolling from leaving a kendo control
    StopKendoScroll: function(element) {
        var activeElement;

        $(document).bind('mousewheel DOMMouseScroll', function(e) {
            var scrollTo = null;

            if (!$(activeElement).closest(".k-popup").length) {
                return;
            }

            if (e.type == 'mousewheel') {
                scrollTo = (e.originalEvent.wheelDelta * -1);
            }

            else if (e.type == 'DOMMouseScroll') {
                scrollTo = 40 * e.originalEvent.detail;
            }

            if (scrollTo) {
                e.preventDefault();
                element.scrollTop(scrollTo + element.scrollTop());
            }

        });

        $(document).on('mouseover', function(e) {
            activeElement = e.target;
        });
    },

    // Get a reference to a function, even if it is name spaced, by name
    GetFunctionByName: function(fn) {

        // Set the function object to the base object (the browser window)
        var fnObj = window;

        // Get the components of the function name
        var fnComponents = fn.split(".");

        // Loop through the function components and get the object for each level as we go
        for (var i = 0; i < fnComponents.length; i++) {
            fnObj = fnObj[fnComponents[i]];

            if (!fnObj) {
                // If we come to a dead end then stop here
                break;
            }
        }
        return fnObj;
    }

};
